var _circle, _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgRiskAlerts(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 44,
    height: 45,
    viewBox: "0 0 44 45",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 22,
    cy: 22.5,
    r: 22,
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.9993 22.5001C21.263 22.5001 20.666 21.9031 20.666 21.1667V18.5001C20.666 17.7637 21.263 17.1667 21.9993 17.1667C22.7357 17.1667 23.3327 17.7637 23.3327 18.5001V21.1667C23.3327 21.9031 22.7357 22.5001 21.9993 22.5001Z",
    fill: "#0B0B17"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M23.3327 25.1667C23.3327 24.4304 22.7357 23.8334 21.9993 23.8334C21.263 23.8334 20.666 24.4304 20.666 25.1667C20.666 25.9031 21.263 26.5001 21.9993 26.5001C22.7357 26.5001 23.3327 25.9031 23.3327 25.1667Z",
    fill: "#0B0B17"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M21.9993 9.16675C14.6356 9.16675 8.66602 15.1363 8.66602 22.5001C8.66601 29.8639 14.6356 35.8334 21.9993 35.8334C29.3631 35.8334 35.3327 29.8639 35.3327 22.5001C35.3327 15.1363 29.3631 9.16675 21.9993 9.16675ZM24.3292 12.0886C25.2952 12.5367 26.1508 13.2802 26.7506 14.319L31.4315 22.4266C32.0713 23.5348 32.2745 24.7269 32.1293 25.8501C32.4776 24.7966 32.666 23.6704 32.666 22.5001C32.666 17.4093 29.0998 13.1515 24.3292 12.0886ZM30.0432 29.5056C28.0878 31.749 25.2091 33.1667 21.9993 33.1667C18.7772 33.1667 15.8887 31.738 13.9328 29.4795C14.845 30.2023 16.0073 30.647 17.3237 30.647H26.6855C27.986 30.647 29.1361 30.213 30.0432 29.5056ZM11.3327 22.5001C11.3327 17.4021 14.909 13.1395 19.6896 12.0842C18.7197 12.5317 17.8604 13.2767 17.2586 14.319L12.5777 22.4266C11.9279 23.5521 11.7285 24.7643 11.887 25.9029C11.5275 24.8342 11.3327 23.6899 11.3327 22.5001ZM19.8224 15.7992C20.7923 14.1194 23.2169 14.1194 24.1868 15.7992L28.8677 23.9069C29.8376 25.5867 28.6253 27.6865 26.6855 27.6865H17.3237C15.3839 27.6865 14.1716 25.5867 15.1415 23.9069L19.8224 15.7992Z",
    fill: "#0B0B17"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRiskAlerts);
export default __webpack_public_path__ + "static/media/risk-alerts.583b0973099e4720405688a1afae6607.svg";
export { ForwardRef as ReactComponent };